import { cn } from '@shared/utils';
import styles from './spinner.module.scss';

interface SpinnerProps {
  className?: string;
  show?: boolean;
  fullscreen?: boolean;
}

export const Spinner = (props: SpinnerProps) => {
  if (props.show === false) return null;
  return (
    <div className={cn(props.fullscreen && 'fixed inset-0 z-50 flex items-center justify-center bg-black/20', props.className)}>
      <div className='mx-auto h-15 w-15'>
        <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 52 52'>
          <circle className={styles.circle1} cx='26' cy='26' r='25' fill='none' />
          <circle className={styles.circle2} cx='26' cy='26' r='18' fill='none' />
          <circle className={styles.circle3} cx='26' cy='26' r='11' fill='none' />
        </svg>
      </div>
    </div>
  );
};
